import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// -----------------------------------------------------------
// IMPORTANT: REPLACE WITH YOUR FIREBASE CONFIGURATION
// -----------------------------------------------------------
// These values are typically safe to expose in client code,
// but it's best practice to use environment variables.

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };
